export default [
  { header: 'Dashboard' },
  { href: '/', title: 'Dashboard Home', icon: 'home', exact: true },
  { href: '/search/fund_search', title: 'Fund Targeting Search' },
  { href: '/search/fund_performance_search', title: '13F Fund Performance Search' },
  { href: '/email_alerts', title: 'Your Email Alerts', icon: 'notifications', badge: true },
  { href: '/groups', title: 'Your Fund Groups', icon: 'group', badge: true },
  { href: '/insider_dashboard', title: 'Insider Dashboard' },
  { href: '/insider_backtester', title: 'Insider Backtester' },
  { href: '/analytics/backtester', title: '13F Backtester' },
  { href: '/tracked_backtests', title: 'Your Tracked Backtests', icon: 'trending_up', badge: true },
  { divider: true },
  { header: 'Tools' },
  {
    title: '13F Analytics',
    icon: 'build',
    group: '/analytics',
    items: [
      { href: '/analytics/backtester', title: '13F Backtester' },
      { href: '/analytics/consensus', title: 'Consensus Holdings' },
      { href: '/analytics/combined', title: 'Combined Holdings' },
      { href: '/analytics/double_down', title: 'Double-Down Report' },
      { href: '/analytics/overlapping_matrix', title: 'Overlap Matrix' }
    ]
  },
  {
    title: '13F Search Tools',
    icon: 'search',
    group: '/search',
    items: [
      { href: '/search/fund_performance_search', title: '13F Fund Performance Search' },
      { href: '/search/fund_search', title: 'Fund Targeting Search' },
      { href: '/search/stock_screener', title: '13F Stock Screener' },
      { href: '/search/sector_search', title: '13F Sector Search' }
    ]
  },

  {
    title: 'Other Dashboard Tools',
    icon: 'domain',
    group: '/other',
    items: [
      { href: '/other/schedule13', title: '13D/G Search' },
      { href: '/other/form_adv_search', title: 'Advisor Search (Form Adv)' },
      { href: '/other/form_d_search', title: 'Form D Search' },
      { href: '/other/nsar_search', title: 'N-SAR Search' },
      { href: '/other/ncen_search', title: 'N-CEN Search' },
      { href: '/other/form4_search', title: 'Insider Transactions' },
      { href: '/insider_dashboard', title: 'Insider Dashboard' }
    ]
  },
  { divider: true },
  { header: 'Additional resources' },
  {
    title: 'Non Dashboard Pages',
    icon: 'search',
    items: [
      { href: '/filing/latest_filings', title: 'Latest 13F Filings', external: true },
      { href: '/report/heat_map', title: '13F Heat Map', external: true },
      { href: '/info/excel_add_in', title: 'Excel Add-in', external: true },
      { href: '/statistics/trends', title: '13F Trend Charts', external: true },
      { href: '/info/statistics_tab', title: '13F Stats', external: true },
      { href: '/statistics/stock_statistics', title: '13F Stock Stats', external: true },
      { href: '/schedule13d', title: 'Latest 13D/G Filings', external: true },
      { href: '/ownership/index_by_day', title: 'Latest Insider Transactions', external: true },
      { href: '/whaleindex', title: 'WhaleIndex', external: true },
      { href: '/whaleindex/index/micro_small_mid', title: 'WhaleIndex Mid/Small/Micro', external: true },
      { href: '/pricing', title: 'Pricing', icon: 'credit_card', external: true }
    ]
  },
  {
    title: 'Site Help',
    icon: 'help',
    items: [
      { href: '/whitepapers/whalewisdom', title: 'How Can WhaleWisdom Help You', external: true },
      { href: '/whitepapers/backtesting', title: 'Backtesting White Paper', external: true },
      { href: '/info/getting_started', title: 'Getting Started', external: true },
      { href: '/info/tutorial_videos', title: 'Video Tutorials', external: true },
      { href: '/info/faq', title: 'FAQ', external: true },
      { href: '/info/investing_13f', title: 'Whale University', external: true },
      { href: '/info/about', title: 'About', external: true },
      { href: '/articles', title: 'Blog and News', external: true },
      { href: '/info/contact', title: 'Contact Us', external: true }
    ]
  },
  { divider: true },
  { header: 'System' },
  { href: '/user', title: 'Account Settings', icon: 'settings' },
  { href: '/login', title: 'Login', icon: 'lock' },
  { href: '/logout', title: 'Logout', icon: 'lock', external: true }
]
